import { renderNav } from '../components/nav.js';
import { DOCS, renderDocsLayout } from '../components/docs-layout.js';

function indexHtml(): string {
  const cards = DOCS.map(
    (d) => `
      <article class="doc-index-card">
        <a class="doc-index-title" href="#/docs/${d.slug}">${d.title}</a>
        <p class="doc-index-summary">${d.summary}</p>
      </article>
    `,
  ).join('');

  return `
    <h1 class="docs-h1">Documentation</h1>
    <p class="docs-intro">References and guides for The Flock protocol, SDKs, and CLI. Source markdown lives in <code>the-flock/docs/</code>.</p>
    <div class="doc-index-grid">${cards}</div>
  `;
}

export function mountDocs(root: HTMLElement): () => void {
  root.innerHTML = `
    ${renderNav({ active: 'docs' })}
    ${renderDocsLayout(null, indexHtml())}
  `;
  return () => {};
}
